/* eslint-disable vue/require-prop-types */
<!-- Components for input tag    -->

<script>
export default {
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  model: {
    event: 'update',
  },
  props: {
    validation: {
      type: Object,
      default() {
        return {}
      },
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-default-prop

    label: {
      type: String,
      default() {
        return ''
      },
    },
    form: {
      type: String,
      default() {
        return ''
      },
    },
    name: {
      type: String,
      default: 'name',
    },
    type: {
      type: String,
      default() {
        return 'text'
      },
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true,
    },
    // Only allow types that essentially just render text boxes.
  },
  data() {
    return {
      data: null,
    }
  },
  computed: {
    disable() {
      return this.options.disable !== undefined ? this.options.disable : false
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.data = this.value
      }
    },
  },
  beforeMount() {
    this.data = this.value
  },
  methods: {
    sendData(event) {
      // EventBus.$emit('testEvent', 'test')
      this.$refs[this.name].reset()
      var data = event.trim()
      if (data === '') data = null

      this.$emit('update', data)
    },
  },
}
</script>

<template>
  <div :class="$style.formGroup" class="formGroup mt20 mt10-sm">
    <div class="formFieldWrap">
      <label
        :for="name"
        :class="$style.fieldTitle"
        class="w40 w100-sm FL pr15 pr0-sm"
        >{{ label }}</label
      >
      <div class="form-field w60 w100-sm FL">
        <div :class="$style.inputField">
          <ValidationProvider
            :ref="name"
            v-slot="{ errors }"
            mode="passive"
            :vid="name"
            :name="name"
            :rules="validation"
          >
            <textarea
              :id="name"
              v-model="data"
              :name="name"
              :type="type"
              :disabled="disable"
              v-bind="$attrs"
              v-on="$listeners"
              @input="sendData($event.target.value)"
            ></textarea>
            <span v-show="errors[0]" :class="$style.error">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.formGroup {
  max-width: 500px;
}
</style>
